<template>
  <div v-if="templateType">
    <app-header
      :title="originalName ? 'Edit ' + originalName : 'New Template Type'"
      subtitle="Template Type"
    >
      <b-button
        variant="primary"
        class="mr-1"
        :disabled="!templateType.name"
        @click="save()"
      >
        Save
      </b-button>
      <cancel-button />
    </app-header>
    <b-container>
      <b-row>
        <b-col md="4">
          <!--Name-->
          <b-form-group>
            <label>Name</label>
            <i class="fa fa-asterisk" style="font-size:8px;color:red" />
            <b-form-input v-model="templateType.name" type="text" required />
          </b-form-group>
          <b-form-group>
            <label>Codename</label>
            <b-form-input v-model="templateType.codename" type="text" />
          </b-form-group>
          <b-form-group>
            <b-form-checkbox v-model="hidden">
              Hidden
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col md="8" />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import AppHeader from '@/components/AppHeader';
import CancelButton from '@/components/CancelButton';

export default {
  components: {
    AppHeader,
    CancelButton,
  },

  data() {
    return {
      originalName: null,
      templateType: null,
      types: [],
      hidden: true,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      $api.get('/v1/internal/templatetypes').then((types) => {
        this.types = types;
      });
      if (this.$route.query.id) {
        $api
          .get(`/v1/internal/templatetypes/${this.$route.query.id}`)
          .then((type) => {
            this.originalName = type.name;
            this.templateType = type;
            this.hidden = !!this.templateType.hidden;
          });
      } else {
        this.templateType = {};
      }
    },

    save() {
      this.templateType.hidden = this.hidden;
      if (this.duplicateName(this.templateType)) {
        // Alert the user if the name has already been used
        // eslint-disable-next-line no-restricted-globals, no-alert
        const createDuplicate = confirm(
          `There is already a template type with the name "${this.templateType.name}".  Continue anyway?`,
        );
        if (!createDuplicate) return;
      }
      if (this.templateType.id) {
        $api
          .put(
            `/v1/internal/templatetypes/${this.templateType.id}`,
            this.templateType,
          )
          .then(this.onSaveSuccess)
          .catch(this.onSaveError);
      } else {
        $api
          .post('/v1/internal/templatetypes', this.templateType)
          .then(this.onSaveSuccess)
          .catch(this.onSaveError);
      }
    },
    onSaveSuccess() {
      this.$router.push({
        name: 'templatetype-list',
      });
    },
    onSaveError(e) {
      console.log('e', e);
      alert(`Error saving template type. ${e}`);
    },

    duplicateName(templateType) {
      // duplicate if name matches and id does not match
      return this.types.some(
        (tt) => tt.name === templateType.name && tt.id !== templateType.id,
      );
    },
  },
};
</script>
